import { render, staticRenderFns } from "./history.vue?vue&type=template&id=6d6374ab&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=6d6374ab&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6374ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d6374ab')) {
      api.createRecord('6d6374ab', component.options)
    } else {
      api.reload('6d6374ab', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=6d6374ab&scoped=true", function () {
      api.rerender('6d6374ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/quote-by-product-sup/inquiryQuotationProduct/history.vue"
export default component.exports